import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/messaging';
// import 'firebase/analytics';

// The configuration below is not sensitive data. You can serenely add your config here
const config = {
  apiKey: "AIzaSyCSDKaYoiF3Tdu2DwePK-oSE7Ghoco0tJQ",
  authDomain: "phox-pwa.firebaseapp.com",
  databaseURL: "https://phox-pwa.firebaseio.com",
  projectId: "phox-pwa",
  storageBucket: "phox-pwa.appspot.com",
  messagingSenderId: "730468146980",
  appId: "1:730468146980:web:f9c9e3e89a88499796ddb1",
  measurementId: "G-1L5WX16ECQ"
};

firebase.initializeApp(config);
// firebase.analytics();
try {
  // getting messaging Object from firebase
  const messaging = firebase.messaging();
  
  messaging.requestPermission().then(function () {
    console.log('Notification permission granted.');
    authToSubscribe(firebase.auth().currentUser)
  }).catch(function (err) { // Happen if user deney permission
    console.log('Unable to get permission to notify.', err);
  });
  
  // do whatever you want on getting push notification in your front application
  messaging.onMessage(function (payload) {
    console.log('onMessage', payload);
  });
  
  firebase.auth().onAuthStateChanged(authToSubscribe);
  async function authToSubscribe(user) {
    try {
      let token = await messaging.getToken();
      console.log('token >>>> ', token);
      let userInLocalStorage = localStorage.getItem('_app_user');
      userInLocalStorage = userInLocalStorage && JSON.parse(userInLocalStorage);
      if (userInLocalStorage) {
        firebase.database().ref('tokens').child(userInLocalStorage.uid).child(token).set(false);
      }
      if (!user) {
        localStorage.removeItem('_app_user')
      } else {
        firebase.database().ref('tokens').child(user.uid).child(token).set(true);
        localStorage.setItem('_app_user', JSON.stringify(user))
      }
    } catch (e) {
      alert(e.message)
    }
  
  }
} catch (err) {
  console.log(err);
}
// fetch("https://us-central1-pwapushnotification-633e2.cloudfunctions.net/helloWorld", {
//   method: 'POST',
//   body: {
//     token: "ewD5MHBousU:APA91bEuIz1bS4E1U9bgZdgO3YBe2Uk9LLhvbzQC_YMtfKNoBHW6lpbXFM-_kqc6PGOXDs63s_5ujhArq32Aq7Q6kQ0ZIirLZxIt630fB5rIc-MZ2rjeiGKfiw1MWS1f2C83zDsViZb075P6lh4tJOqMPcI_y-dgNA",
//     title: "my title",
//     message: "my body message"
//   },
//   headers: {
//     'Content-Type': 'application/json'
//   }
// }).then((res) => res)
